import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { CheckCircle, WarningRounded } from '@material-ui/icons';
import { GREEN_MOBILE, YELLOW_MOBILE } from 'constants/colors';
import React, { FC } from 'react';

interface Props {
  open: boolean;
  isLoadingPrint: boolean;
  deliveryPrint: () => void;
  handleSkip: () => void;
}
const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: '2em',
    display: 'flex',
    rowGap: '0.8em',
    flexDirection: 'column'
  },
  button: {
    borderRadius: '5px',
    padding: '7px 0'
  }
}));
const ModalSuccess: FC<Props> = ({ open, deliveryPrint, isLoadingPrint, handleSkip }) => {
  const classes = useStyles();
  return (
    <Dialog open={open}>
      <Grid xs={12} className={classes.container}>
        <Grid item container direction='column' alignItems='center' xs={12}>
          <CheckCircle style={{ color: GREEN_MOBILE, fontSize: '3.5rem' }} />
          <Typography variant='h4'>Sukses Menambahkan!</Typography>
        </Grid>

        <Grid xs={12} container justify='center'>
          <Grid xs={10}>
            <Typography align='center' variant='h6'>
              Ingin Cetak Surat Jalan Sekarang?
            </Typography>
          </Grid>
        </Grid>

        <Grid xs={12} container justify='center'>
          <Grid xs={12} container style={{ columnGap: '1.5em' }} justify='center'>
            <Grid xs={5}>
              <Button size='small' fullWidth className={classes.button} color='primary' variant='outlined' onClick={handleSkip}>
                Skip Nanti
              </Button>
            </Grid>
            <Grid xs={5}>
              <Button size='small' fullWidth className={classes.button} color='primary' onClick={deliveryPrint} disabled={isLoadingPrint}>
                {isLoadingPrint ? <CircularProgress size={22} color='primary' /> : 'Cetak Sekarang'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ModalSuccess;
